import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/service/auth.service';
import { RestClientService } from 'src/app/core/service/rest-client.service';
import { UtilitiesService } from 'src/app/core/service/utilities.service';
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";


@Component({
  selector: 'app-historique-navigation',
  templateUrl: './historique-navigation.component.html',
  styleUrls: ['./historique-navigation.component.scss']
})
export class HistoriqueNavigationComponent implements OnInit {

listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint : string = 'userNavigationHistory';
  itemsRole: any;
  itemsSpecialites: any;
  dateNais: any;
  bsValue: Date;
  ListNoParentFonctionnalites: any[];
  searchKey: any;
  itemsFiliale: any[];
  filiale_id:any
  constructor(private authService: AuthService, private restClient: RestClientService, private modalService: BsModalService, private utilities: UtilitiesService) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id
  }

  pageChanged(event: any): void {
    this.currentPage = event.page ;
    this.getItems();
  }
  resetForm(){
    this.itemToSave.typeActeId=null
    this.itemToSave.libelle=''
  }

  

  openModal(data: any, template: TemplateRef<any>) {
    let config = {backdrop: true, ignoreBackdropClick: true,id: 1, class: 'modal-md'};
    this.itemToSave = {};
    if (data) {
      console.info('data',data);
      // Lorsque nous sommes en modification
      // this.bsValue = data.dateNais
      this.itemToSave = Object.assign({}, data);
      if(data.parentId){
        this.itemToSave.parentId=data.parentId
      }

    }

    this.modalRef = this.modalService.show(template,config);
  }


  
  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      // order_by:'created_at',
      data: {
        
      },
      index: this.currentPage,
      size: this.itemsPerPage
    }

    this.busyGet = this.restClient.post(this.endPoint+'/getByCriteria', request)
      .subscribe(
        res => {
          if (res && res['items']) {
            this.items = res['items'];
            console.info('all fonct',this.items);
            
            this.totalItems = res['count'];

          }
          else {
            this.items = [];
            this.totalItems = 0;
          }
        },
        err => {
        }
      );
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: this.currentPage,
      size: this.itemsPerPage,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  confirmDelete(item){
    Swal.fire({
      title: "Suppression",
      text: "Vous êtes sur le point de supprimer un élément. Voulez-vous poursuivre cette action ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3f51b5",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.deleteItem(item);
      }
    });
  };

  deleteItem(obj) {

    var request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      datas: [
        obj
      ]
    }

    this.busyGet = this.restClient.post(this.endPoint+'/delete', request)
      .subscribe(
        res => {
          console.info(res);
          if (!res['hasError']) {
            this.utilities.showNotification("snackbar-success",
              this.utilities.formatMsgServeur(res['status']['message']),
              "bottom",
              "center");

            this.currentPage = 0;
            this.getItems();
          }
          else {
            if (res['status'] && res['status']['message']) {
              this.utilities.showNotification("snackbar-danger",
                this.utilities.formatMsgServeur(res['status']['message']),
                "bottom",
                "center");
            }
          }

        },
        err => {
          console.info("Error occured", err);
          this.utilities.showNotification("snackbar-danger", err || this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center");
        }
      );
  }

  onSelectDate(event){
    if(event){
      this.dateNais = moment(event).format('DD/MM/YYYY'),
      console.info('dateNais',this.dateNais);

    }
  }
  toggleIsMedecin(itemToToggle){
    itemToToggle.isMedecin = !itemToToggle.isMedecin
  }
  changePaginationSize($event) {
    if($event) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt($event);
    }
    this.getItems();
  }

  ngOnInit() {
    this.resetForm()
    this.getItems();
    this.getItemsFiliale()
  }


}
